import { createClient } from './client'
import type { Client } from './client'

export interface Api extends Client {
  new (baseUrl: string, token: string): Client
}

export class Api {
  constructor(baseUrl: string, token: string) {
    // we're abusing the `Api` interface overload with this type/class mechanics here
    // so that we can return an instance of `Api` from the constructor
    // to satisfy types in ApiRequest functions and enforce an instance that has the url and token set,
    // but really all we want is to return a wretch object that's chainable for the consumers
    // to create their requests
    return createClient(baseUrl).headers({
      Authorization: `Bearer ${token}`,
    }) as Api
  }
}

export type ApiRequest<T = unknown> = (
  api: Api,
  // For generic purposes this needs to be `any` because we don't know the shape of args ahead of time
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => (arg0: any) => Promise<T>
